export default function Comparison({ oldData, newData }) {
  return (
    <div className="compare">
      <div className="box old">
        <h3>🟠 Old Regime</h3>
        <p>Tax: ₹ {oldData.tax}</p>
        <p>Net: ₹ {oldData.net}</p>
        <p>Deduction: ₹ {oldData.deduction}</p>
      </div>

      <div className="box new">
        <h3>🟢 New Regime</h3>
        <p>Tax: ₹ {newData.tax}</p>
        <p>Net: ₹ {newData.net}</p>
        <p>Deduction: ₹ {newData.deduction}</p>
      </div>
    </div>
  );
}